import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-compare-and-update-candidate-details',
  templateUrl: './compare-and-update-candidate-details.component.html',
  styleUrls: ['./compare-and-update-candidate-details.component.css']
})
export class CompareAndUpdateCandidateDetailsComponent implements OnInit {

  @Input() candidateConflictDetails: any;
  @Output() saveCallback = new EventEmitter<{ contactDetails: any }>();
  @Output() cancelCallback = new EventEmitter<{ contactDetails: any } | null>();

  ngOnInit() {
    this._setFields();
  }

  private _setFields() {
    this.candidateConflictDetails.candidateConflictDetails.forEach((conflict: any) => {
      conflict.fieldId = conflict.fieldName.split(' ').join('-');
      conflict.selectedValue = conflict.newValue;
      conflict.newValueSelected = true;
    });
  }

  updateField(index: number, flag: boolean) {
    if (flag) {
      this.candidateConflictDetails.candidateConflictDetails[index].selectedValue =
        this.candidateConflictDetails.candidateConflictDetails[index].newValue;
    } else {
      this.candidateConflictDetails.candidateConflictDetails[index].selectedValue =
        this.candidateConflictDetails.candidateConflictDetails[index].oldValue;
    }
  }

  save() {
    const contactDetails = this._contactDetailsFromSelection();
    this.saveCallback.emit({ contactDetails: contactDetails });
  }

  cancel() {
    if (this.candidateConflictDetails && this.candidateConflictDetails.candidateConflictDetails.length > 0) {
      const contactDetails = this._contactDetailsFromSelection();
      this.cancelCallback.emit({ contactDetails: contactDetails });
    } else {
      this.cancelCallback.emit(null);
    }
  }

  private _contactDetailsFromSelection() {
    return {
      firstName: this.candidateConflictDetails.candidateConflictDetails[0].selectedValue,
      lastName: this.candidateConflictDetails.candidateConflictDetails[1].selectedValue,
      email: this.candidateConflictDetails.candidateConflictDetails[2].selectedValue,
      phoneNumber: this.candidateConflictDetails.candidateConflictDetails[3].selectedValue
    };
  }
}
